import React from 'react';
import { InputAdornment, TextField as MuiTextfield } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import styles from './textField.style';

const TextField = ({
  name,
  placeholder = 'Empty',
  type = 'text',
  label = '',
  disabled = false,
  onChange,
  value = '',
  error,
  readonly,
  ...rest
}) => {
  const _handleChange = (e) => {
    onChange(e.target.value);
  };

  const handleKeyUp = (e) => {
    if (
      type === 'number' &&
      ((rest.max && e.target.value > rest.max) ||
        (rest.min && e.target.value < rest.min))
    ) {
      return onChange('');
    }
  };

  const hasValueAndNoError = Boolean(!error && value != null && value !== '');

  return (
    <MuiTextfield
      size="small"
      label={label}
      error={!!error}
      onChange={_handleChange}
      value={value ?? ''}
      type={type}
      disabled={disabled}
      variant="outlined"
      placeholder={placeholder}
      data-testid={`input-${name}`}
      sx={{
        ...styles.textfield,
        ...(hasValueAndNoError && styles.successTextInput),
      }}
      onKeyUp={handleKeyUp}
      {...rest}
      InputProps={{
        readOnly: readonly,
        endAdornment: (
          <InputAdornment position="end">
            {error && (
              <WarningIcon data-testid="WarningIcon" sx={styles.warningIcon} />
            )}
            {hasValueAndNoError && (
              <CheckCircleIcon
                data-testid="CheckCircleIcon"
                sx={styles.successIcon}
              />
            )}
          </InputAdornment>
        ),
        ...rest?.InputProps,
      }}
    />
  );
};

export default TextField;
